import { render } from "./AddToCart2.vue?vue&type=template&id=d99e3d5a&scoped=true"
import script from "./AddToCart2.vue?vue&type=script&lang=js"
export * from "./AddToCart2.vue?vue&type=script&lang=js"

import "./AddToCart2.vue?vue&type=style&index=0&id=d99e3d5a&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d99e3d5a"]])

export default __exports__